import { useLinkConversationToSubmissionMutation } from "@qw/graphql";
import { Button, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";
import { type FC, useCallback } from "react";

export const LinkSubmissionButton: FC<{
  conversationId: string;
  submissionId: string;
}> = ({ conversationId, submissionId }) => {
  const [linkConversationToSubmission] = useLinkConversationToSubmissionMutation({
    refetchQueries: ["InboxConversation"],
  });

  const handleClick = useCallback(async () => {
    await linkConversationToSubmission({
      variables: { input: { conversationId, submissionId } },
    });
  }, [conversationId, submissionId, linkConversationToSubmission]);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="xs"
          display="icon"
          className="group/button opacity-0 group-hover:opacity-100 transition-opacity"
          onClick={handleClick}
        >
          <Icon icon="link_off" className="group-hover/button:hidden" />
          <Icon icon="link" className="hidden group-hover/button:inline" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Link Submission</TooltipContent>
    </Tooltip>
  );
};
